import React, { useState, useEffect } from 'react';
import { TextField}  from "@material-ui/core";
import cn from './PaymentPlanPriceRange.module.scss';


export function PaymentPlanPriceRange( { initialMinPrice, initialMaxPrice, onChange }) {
  const [ minPrice, setMinPrice ] = useState(initialMinPrice);
  const [ maxPrice, setMaxPrice ] = useState(initialMaxPrice);

  useEffect(() => {
    setMinPrice(initialMinPrice);
  }, [initialMinPrice]);

  useEffect(() => {
    setMaxPrice(initialMaxPrice)
  }, [initialMaxPrice]);

  const handleMinPriceChange = (event) => {
    const value = event.target.value ? parseInt(event.target.value) : "";
    const price = isNaN(value) ? 0 : value;
    setMinPrice(price);
    onChange({ minPrice: price, maxPrice });
  };

  const handleMaxPriceChange = (event) => {
    const value = event.target.value ? parseInt(event.target.value) : "";
    const price = isNaN(value) ? 0 : value;
    setMaxPrice(price);
    onChange({ minPrice, maxPrice: price });
  };

  return (
    <div>
      <div>Application price range</div>
      <div className={cn.priceRange}>
        <TextField
          label="Min"
          name="minPrice"
          value={minPrice}
          onChange={handleMinPriceChange}
          InputProps={{
            endAdornment: '$'
          }}
          className={cn.priceRangeInput}
        />
        <TextField
          label="Max"
          name="maxPrice"
          value={maxPrice}
          onChange={handleMaxPriceChange}
          InputProps={{
            endAdornment: '$'
          }}
        />
      </div>
    </div>
  );
}
